import { render, staticRenderFns } from "./InstapaperButton.vue?vue&type=template&id=004407e0&scoped=true&"
import script from "./InstapaperButton.vue?vue&type=script&lang=js&"
export * from "./InstapaperButton.vue?vue&type=script&lang=js&"
import style0 from "./InstapaperButton.vue?vue&type=style&index=0&id=004407e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004407e0",
  null
  
)

export default component.exports